"use client"
import { getSectionPaddingClass, getThemeClass } from "~/styles/styles"
import Section from "../../common/section"
import SplitTextSection, { type SplitTextProps } from "../../section/splitText"
import Image from "next/image"
import { ArrowLongRightIcon } from "@heroicons/react/20/solid"
import puppyImg1 from "public/images/about-us/sustainability/Puppy1.png"
import puppyImg2 from "public/images/about-us/sustainability/Puppy2.png"
import puppyImg3 from "public/images/about-us/sustainability/Guide Dogs Puppies.png"
import { useNavigationController } from "~/app/utils/navHelper"
import { CommunityAndSustainability } from "~/content/navLinks"
import heartImg from "public/images/hearts/Half-heart-element.png"

import { CHARITIES_SECTION_CONSTANTS } from "~/app/about-us/community-and-sustainability/CHARITIES_SECTION_CONSTANTS"
import SplitCTASection from "../../section/splitCTA"

const GuideDogSection = ({ ...props }: SplitTextProps) => {
  const padding = `${getSectionPaddingClass("default-y")} xl:py-60 px-8 lg:px-4 ${props.customPadding ? "pb-48 xs:pb-48 sm:pb-48" : ""}`
  const imageAnimation = "scale-100 hover:scale-110 transition-transform"
  const imageClass = `rounded-full max-w-80 mx-auto md:mx-0 aspect-square overflow-hidden flex-grow`
  const alignClass = `xl:text-left xl:ml-auto xl:max-w-[30rem]`

  const { navOnClick } = useNavigationController()

  return (
    <>
      <SplitTextSection
        theme="dark-purpleblue"
        title={<h2 className="text-green-light font-bold mb-1">Supporting people with low and no vision</h2>}
        body={"Each year, we sponsor the training of guide dogs."}
        image={puppyImg3}
        imageClass="w-full md:w-5/6"
        iconImage={heartImg}
        padding={`${getSectionPaddingClass("base")}`}
      />
    </>
    // <Section className={`relative flex ${getThemeClass("light")} `}>
    //   <div className={`relative mx-auto flex w-full xl:max-w-6xl`}>
    //     <div
    //       className={`container z-10 mx-auto flex flex-col justify-center gap-10 ${padding} `}
    //     >
    //       <div className={`${props.textRight ? "order-last" : "order-left"} `}>
    //         <div className={`text-center`}>
    //           <h2
    //             className={`text-resp-4xl mb-4 font-bold text-purpleblue md:mb-8 xl:mb-12 xl:text-right`}
    //           >
    //             Meet Dora and Margot, our L plate guide dogs
    //           </h2>
    //           <div
    //             className={`mx-auto max-w-lg sm:w-4/5 xl:mx-0 ${alignClass} text-desk-resp-xl text-grey-85`}
    //           >
    //             <p>
    //               Each year, we sponsor guide dogs in training through Guide
    //               Dogs Victoria and Guide Dogs NSW/ACT and this year, our two
    //               sponsored are Dora and Margot.
    //             </p>
    //           </div>
    //           <div className={`mt-6 text-center leading-3 ${alignClass}`}>
    //             <a
    //               className={`text-desk-resp-xl cursor-pointer font-bold text-purpleblue hover:rounded-lg hover:bg-purpleblue/20 hover:px-4 hover:py-2`}
    //               onClick={() => {
    //                 navOnClick(
    //                   `${CommunityAndSustainability.href}`,
    //                   CHARITIES_SECTION_CONSTANTS.CHARITY,
    //                 );
    //               }}
    //             >
    //               Who we support
    //               <ArrowLongRightIcon className="mb-0.5 ml-1 inline size-5 lg:size-6" />
    //             </a>
    //           </div>
    //         </div>
    //       </div>

    //       <div
    //         className={`flex flex-col gap-4 xs:flex-row md:gap-8 xl:absolute`}
    //       >
    //         <div className={`${imageClass} md:ml-auto xl:-translate-y-28`}>
    //           <Image
    //             src={puppyImg1}
    //             alt="puppy-image"
    //             className={` ${imageAnimation} `}
    //           />
    //         </div>
    //         <div
    //           className={`${imageClass} md:mr-auto xl:-translate-x-24 xl:translate-y-32`}
    //         >
    //           <Image
    //             src={puppyImg2}
    //             alt="puppy-image"
    //             className={`${imageAnimation} `}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </Section>
  )
}

export default GuideDogSection
